export default {
	plans: {
		title: "Planes y Precios",
		subtitle: "Elige el plan ideal para tu templo",
		perMonth: "/mes",
		freeTrial: "30 días gratis para probar",
		getStarted: "Comenzar Ahora",
		empty: "Planes próximamente",
		emptyDesc: "Estamos preparando los planes. ¡Vuelve pronto!",
		backToStart: "Volver al inicio",
	},
	builder: {
		foundation: "Base",
		addons: "Complementos",
		yourPlan: "Tu plan",
		includedAlways: "Siempre incluido",
		unlimitedChain: "Miembros ilimitados, todo incluido",
		notInclude: "No incluir",
		total: "Total",
		subscribeNow: "Suscribirse ahora",
		editPlan: "Editar plan",
		editPlanTitle: "Arma tu plan",
		editDone: "Listo",
		preselectionUnavailable: "El plan o complemento elegido anteriormente ya no está disponible. Revisa la selección de abajo antes de confirmar.",
		startFree: "Probar 30 días gratis",
		trialNote: "Los complementos no entran en la prueba gratis — suscríbete para activarlos desde el primer día.",
		trialConfirm: {
			title: "Prueba gratis de 30 días",
			message:
				"Durante la prueba gratis usas las funciones del plan, pero los complementos (WhatsApp, Mercado Pago) no se incluyen. Para usarlos, suscríbete a un plan.",
			withAddons:
				"Los complementos que elegiste ({addons}) no entran en la prueba gratis. Suscríbete para activarlos desde el primer día.",
			subscribeInstead: "Suscribirse a un plan",
			continueTrial: "Continuar con la prueba gratis",
		},
		optional: "opcional",
		needMore: "¿Necesitas más? ¡Contáctanos!",
		needMoreSubject: "Necesito un plan a medida",
		group: {
			whatsapp: "Alertas de WhatsApp",
			mercadoPago: "Integración Mercado Pago",
		},
	},
	trial: {
		banner: "Período de prueba: {days} días restantes",
	},
	voucher: {
		label: "Código del voucher",
		placeholder: "Ej: ORI2026",
		apply: "Aplicar",
		valid: "¡Voucher aplicado con éxito!",
		invalid: "Voucher inválido",
		applied: "Descuento del voucher",
		activated: "¡Suscripción activada con éxito!",
	},
	dialog: {
		title: "Elige tu plan",
		subtitle: "Selecciona un plan para suscribirte",
		confirm: "Continuar",
		cancel: "Cancelar",
	},
	return: {
		checkingTitle: "Confirmando tu pago...",
		checkingDesc: "Esto solo toma unos segundos.",
		successTitle: "¡Gracias por tu compra!",
		successDesc: "Tu suscripción está activada.",
		successDescPlan: "Tu suscripción al plan {plan} está activada.",
		pendingTitle: "Estamos confirmando tu pago",
		pendingDesc: "La confirmación puede tardar unos minutos. Si el pago se completó, tu plan se activará automáticamente. Si no se completó o fue rechazado, puedes intentarlo de nuevo en la página del plan.",
		viewMyPlan: "Ver mi plan",
		goToDashboard: "Ir al panel",
	},
	blocked: {
		ownerTitle: "Tu suscripción ha expirado",
		ownerDesc: "El período de prueba terminó o el pago no fue confirmado. Suscríbete a un plan para continuar usando ORI.",
		memberTitle: "Acceso suspendido",
		memberDesc: "El acceso al sistema está temporalmente suspendido. Contacta al responsable del templo para regularizar la suscripción.",
		currentTemple: "Templo actual:",
		otherTemples: "O accede a otro templo de tu cuenta:",
		pendingCheckout: "Comenzaste a contratar un plan y no completaste el pago:",
		resumeCheckout: "Continuar donde lo dejé",
		chooseAnother: "Elegir otro plan",
		logout: "Salir",
	},
	page: {
		title: "Mi Plan",
		plan: "Plan",
		trialExpiresIn: "Prueba expira en",
		daysLeft: "({days} días restantes)",
		nextPayment: "Próximo vencimiento",
		accessUntil: "Acceso hasta",
		subscribeNow: "Suscribirse Ahora",
		cancelSubscription: "Cancelar Suscripción",
		changePlan: "Cambiar plan",
		paymentHistory: "Historial de Pagos",
		noPayments: "Sin pagos",
		noPaymentsDesc: "Tu historial de pagos aparecerá aquí.",
		headerAmount: "Valor",
		headerStatus: "Estado",
		headerPaidAt: "Pagado en",
		headerPeriod: "Período",
		cancelTitle: "Cancelar Suscripción",
		cancelConfirm: "¿Estás seguro de que deseas cancelar tu suscripción? El acceso se mantendrá hasta el final del período actual.",
		cancelNo: "No",
		cancelYes: "Sí, cancelar",
		cancelSuccess: "Suscripción cancelada. Acceso mantenido hasta el final del período.",
		errorSubscribe: "Error al iniciar suscripción",
		errorCancel: "Error al cancelar suscripción",
		errorLoad: "Error al cargar datos del plan",
		voucher: {
			comped: "Cortesía",
			compedUntil: "Cortesía hasta {date}",
			discountPercent: "Descuento del {value}%",
			discountAmount: "Descuento de R$ {value}",
			payFullPrice: "Pagar precio completo",
			payFullPriceConfirm: "A partir de la próxima factura, Mercado Pago cobra el precio completo del plan.",
			back: "Volver",
			payFullPriceSuccess: "Descuento finalizado.",
			payFullPriceError: "Error al finalizar el descuento",
		},
		status: {
			TRIALING: "Período de Prueba",
			ACTIVE: "Activa",
			PAST_DUE: "Pago Pendiente",
			SUSPENDED: "Suspendida",
			CANCELLED: "Cancelada",
			NO_SUBSCRIPTION: "Sin Suscripción",
		},
		statusDesc: {
			TRIALING: "Estás en el período de prueba gratuito.",
			ACTIVE: "Tu suscripción está activa y al día.",
			PAST_DUE: "Tu último pago falló. Regulariza para mantener el acceso.",
			SUSPENDED: "Acceso suspendido. Suscríbete para reactivar.",
			CANCELLED: "Suscripción cancelada. El acceso continúa hasta el fin del período actual.",
			CANCELLED_EXPIRED: "Suscripción cancelada y período finalizado. Suscríbete para volver a usar ORI.",
			NO_SUBSCRIPTION: "Suscríbete para comenzar a usar ORI.",
		},
		paymentStatus: {
			PAID: "Pagado",
			PENDING: "Pendiente",
			FAILED: "Falló",
			REFUNDED: "Reembolsado",
		},
	},
	usage: {
		title: "Uso del plan",
		unlimited: "ilimitado",
		estimate: "La cantidad de mensajes es una estimación y varía según los recursos activados.",
		limitKey: {
			corrente: "Miembros activos",
			whatsappMsgMonth: "Mensajes de WhatsApp/mes",
		},
	},
	upgrade: {
		title: "Límite del plan alcanzado",
		cta: "Ver planes",
		defaultMessage:
			"Este recurso no está incluido en tu plan actual. Mejora tu plan para desbloquearlo.",
	},
	changePlan: {
		title: "Cambiar de plan",
		current: "actual",
		upgradeNote:
			"Las mejoras tienen efecto inmediato. La diferencia proporcional de los días restantes entra en la próxima factura.",
		downgradeNote:
			"El cambio a un plan menor se programa para el fin del período actual — el acceso continúa hasta entonces.",
		confirm: "Cambiar plan",
		upgraded: "¡Plan cambiado! Prorrateo de R$ {amount} en la próxima factura.",
		scheduled: "Cambio programado para el fin del período actual.",
		changed: "Plan cambiado con éxito.",
		error: "Error al cambiar de plan",
	},
	addons: {
		title: "Complementos",
		subtitle: "Recursos adicionales para tu plan",
		contracted: "Activo",
		contract: "Contratar",
		change: "Cambiar a este nivel",
		remove: "Quitar",
		perMonth: "/mes",
		prorationWarning:
			"El acceso se libera al instante. El importe proporcional a los días restantes se sumará a tu próxima factura; las siguientes vendrán con el importe completo.",
		contractTitle: "Contratar complemento",
		activated: "¡Complemento activado! Proporcional de R$ {amount} en tu próxima factura.",
		activatedNoProration: "¡Complemento activado!",
		removeTitle: "Quitar complemento",
		removeText:
			"El complemento sigue activo hasta el fin del período actual y no se renovará. Sin reembolso.",
		removeScheduled: "Eliminación programada para el fin del período actual.",
		scheduledForEnd: "Cambio programado para el fin del período actual.",
		pendingProration:
			"R$ {amount} (proporcional) se sumarán a tu próxima factura.",
		hasScheduledChange:
			"Tienes un cambio de plan programado para el fin del período actual.",
		error: "Error al cambiar el complemento",
	},
};
